<template>
  <b-card
    :class="{ 'border-primary': skin === 'dark', 'border-secondary border-lighten-5': skin === 'light' }"
  >
    <div class="d-flex mt-2 text-primary m-2">
      <feather-icon
        icon="UsersIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50 text-primary">
        Tipo de usuario
      </h4>
    </div>
    <template>
      <b-list-group class="my-2 w-100">
        <b-list-group-item
          v-for="gruposv in userData.grupos"
          :key="gruposv.grupo"
          class="d-flex"
        >
          <div :class="`d-flex align-items-center text-${resolveUserGrupoVariant(gruposv.grupo)}`">
            {{ gruposv.grupo }}
          </div>
          <div v-if="gruposv.grupo=='Alumno'">
            <br><feather-icon
              icon="UserIcon"
              size="18"
              class=" text-success mr-50"
            />
            Matricula - {{ gruposv.matricula }}
          </div>
        </b-list-group-item>
      </b-list-group>
    </template>
  </b-card>
</template>

<script>
import {
  BCard, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  configTableUsuarios,
} from '@/views/campus/usuarios/useUsuarios'
import store from '@/store'
import { computed } from '@vue/composition-api'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BListGroup,
    BListGroupItem,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const skin = computed({
      get: () => store.state.appConfig.layout.skin,
    })
    const { resolveUserrolVariant } = configTableUsuarios()
    const { resolveUserGrupoVariant } = configTableUsuarios()
    const { resolveUserrolIcon } = configTableUsuarios()
    return {
      skin,
      resolveUserrolVariant,
      resolveUserrolIcon,
      resolveUserGrupoVariant,
    }
  },
}
</script>

<style>

</style>
